export class DMS {
  changeDetails: Array<ChangeDetails>;
  observations: Array<ChangeObservations>;

  constructor(changeDetails: Array<ChangeDetails>, observations: Array<ChangeObservations>) {
    this.changeDetails = changeDetails;
    this.observations = observations;
  }
}

export class ChangeDetails {
  fieldToChange: string;
  newValue: any;

  constructor(ftc: string, nv: any) {
    this.fieldToChange = ftc;
    this.newValue = nv;
  }
}

export class ChangeObservations {
  matchKey: string
  rowKey: string;

  constructor(matchKey: string, rowKey: string) {
    this.matchKey = matchKey;
    this.rowKey = rowKey;
  }
}
